import React, { useEffect, useState } from 'react';
import { useDeviceType } from 'common-utilities';
import ContentLoader from 'react-content-loader';
import { If, When, Choose, Otherwise } from 'babel-plugin-jsx-control-statements';
import { useHistory } from 'react-router-dom';
import {
	Pulse,
	DEVICES,
	getCurrentEnv,
	NavigationHelpers,
	NetworkHelper,
	fetchPropertyConfig
} from 'common-utilities';
import Footer from '../../components/footer';
import FooterLines from '../../components/footerLines';
import { EVENT_CATEGORY } from '../../constants';
import PrimaryButton from '../../components/primaryButton';
import NProgress from 'nprogress';
import PaytmLogo from '../../assets/paytmSheild.svg';
import './style.scss';
import 'nprogress/nprogress.css';

const ENV = getCurrentEnv();
const screenName = '/unblock_otp_home';
NProgress.configure({ showSpinner: false });
function Home({ state }) {
	const DEVICE = useDeviceType();
	const [userDetails, setUserDetails] = useState({});
	const history = useHistory();
	const [apiStatus, setApiStatus] = useState(NetworkHelper.API_STATUS.NOT_STARTED);
	const [logoutStatus, setLogoutStatus] = useState(NetworkHelper.API_STATUS.NOT_STARTED);
	const handleReport = e => {
		setLogoutStatus(NetworkHelper.API_STATUS.INITIALIZED);
		NProgress.start({
			showSpinner: false
		});
		NetworkHelper.put(`${ENV}/um/unblock/fraud?code=${state.searchToken}`)
			.then(data => {
				sessionStorage && sessionStorage.setItem('API_RESULT', state.searchToken);
				NProgress.done();
				setLogoutStatus(NetworkHelper.API_STATUS.SUCCESS);
				Pulse.push({
					event_action: 'confirm_clicked',
					event_category: EVENT_CATEGORY,
					screenName,
					event_label: 'success'
				});
				history.push('/success');
			})
			.catch(e => {
				NProgress.done();
				setLogoutStatus(NetworkHelper.API_STATUS.FAILURE);
				Pulse.push({
					event_action: 'confirm_clicked',
					event_category: EVENT_CATEGORY,
					screenName,
					event_label: 'Failure',
					event_label2: JSON.stringify(e)
				});
				history.push('/error');
			});
	};
	const setConfigData = async () => {
		sessionStorage &&
			sessionStorage.setItem(
				'REDIRECT_PAYTM_DEEPLINK',
				await fetchPropertyConfig('redirectPaytmDeepLink')
			);
	};
	useEffect(() => {
		setApiStatus(NetworkHelper.API_STATUS.INITIALIZED);
		setConfigData();
		NetworkHelper.get(`${ENV}/user/token/info?stateCode=${state.searchToken}`)
			.then(data => {
				setUserDetails(data);
				setApiStatus(NetworkHelper.API_STATUS.SUCCESS);
				sessionStorage && sessionStorage.setItem('state', JSON.stringify(data));
				setTimeout(() => {
					Pulse.push({
						event_action: 'unblock_otp_page_loaded',
						event_category: EVENT_CATEGORY,
						screenName,
						event_label: data.communicationType
					});
				});
			})
			.catch(err => {
				setApiStatus(NetworkHelper.API_STATUS.FAILURE);
				history.push('/error');
			});
	}, []);
	return (
		<React.Fragment>
			<div className="homePageContainer">
				<div className="imageContainer">
					<img src={PaytmLogo} alt="paytm-icon" />
				</div>
				<div className="heading">Unblock OTP Service</div>
				<Choose>
					<When condition={apiStatus === NetworkHelper.API_STATUS.SUCCESS}>
						<div className="text-container">
							Upon your request, OTP service was blocked on {userDetails.timestamp}{' '}
							for your mobile number: {userDetails.moblieNumber}.
						</div>
						<div className="text-container">
							If you wish to restart the service immediately, please confirm.
						</div>
						<Choose>
							<When condition={DEVICE === DEVICES.DESKTOP}>
								<div className="buttonContainer">
									<PrimaryButton
										onClick={e =>
											apiStatus === NetworkHelper.API_STATUS.SUCCESS &&
											logoutStatus !== NetworkHelper.API_STATUS.INITIALIZED
												? handleReport(e)
												: null
										}
										oauth-id="confirm_btn"
									>
										Confirm
									</PrimaryButton>
								</div>
							</When>
							<Otherwise>
								<div className="mobileButtonContainer">
									<button
										className="button primary"
										onClick={e =>
											apiStatus === NetworkHelper.API_STATUS.SUCCESS
												? handleReport(e)
												: null
										}
										oauth-id="confirm_btn"
									>
										Confirm
									</button>
								</div>
							</Otherwise>
						</Choose>
					</When>
					<Otherwise>
						<ContentLoader animate={true} width={200} viewBox="0 0 200 70">
							<rect x="0" y="4" rx="2" ry="2" width="200" height="8" />
							<rect x="0" y="20" rx="2" ry="2" width="200" height="8" />
							<rect x="0" y="36" rx="2" ry="2" width="160" height="8" />
							<rect x="0" y="52" rx="2" ry="2" width="200" height="8" />
						</ContentLoader>
					</Otherwise>
				</Choose>
			</div>
			{DEVICE === DEVICES.DESKTOP ? <Footer /> : <FooterLines />}
		</React.Fragment>
	);
}
export default Home;
